import {Component} from '@angular/core';

@Component({
	selector: 'workflow-dev-null',
	template: '',
})
export class DevNullComponent {

}
